import { pagination } from './templates';

export default {
    products: [],
    pagination: { ...pagination }
};
